import { render, staticRenderFns } from "./PLPCareplanImageBanner.vue?vue&type=template&id=f158fc3c&scoped=true&"
import script from "./PLPCareplanImageBanner.vue?vue&type=script&lang=ts&"
export * from "./PLPCareplanImageBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PLPCareplanImageBanner.vue?vue&type=style&index=0&id=f158fc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f158fc3c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsKEButton: require('/var/www/packages/theme/components/atoms/KEButton.vue').default})
